import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { VerticaCopySource } from 'app/model/pipeline/copysource/vertica.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(VerticaCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class VerticaCopySourceAdapter extends CopySourceAdapter<VerticaCopySource, Model.VerticaSource> {
    protected override async _toResource(copySource: VerticaCopySource): Promise<Model.VerticaSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(VerticaCopySource).name);
    }

    protected override async _toModel(
        resource: Model.VerticaSource,
        copyActivity: CopyActivity
    ): Promise<VerticaCopySource> {
        return this._toTabularModel(resource, copyActivity, VerticaCopySource.MODEL);
    }
}
